import defaultLayout from '../../layouts/default'
import simpleLayout from '../../layouts/simple'
import innerLayout from '../../layouts/inner'
import { useLoginStatus } from '@/utils/useStore'

export default {
  path: 'site',
  component: defaultLayout,
  alias: '',
  children: [
    {
      path: 'autoSave',
      component: () => import('./autoSave'),
      meta: {
        auth: true
      }
    },
    {
      path: '',
      component: useLoginStatus() ? innerLayout : simpleLayout,
      children: [
        {
          path: 'roledetail',
          component: () => import('./roledetail')
        }
      ]
    },
    {
      path: '',
      component: simpleLayout,
      children: [
        {
          path: 'terms',
          component: () => import('./terms')
        },
        {
          path: 'privacy',
          component: () => import('./privacy')
        },
        {
          path: 'childPrivacy',
          component: () => import('./childPrivacy')
        },
        {
          path: 'thirdParty',
          component: () => import('./thirdParty')
        }
      ]
    }
  ]
}
